import React from "react";
import LocalizedWeatherGuidePage from "@/components/weather/LocalizedWeatherGuidePage";

export default function WindGuide() {
  return <LocalizedWeatherGuidePage guideKey="wind" />;
}